import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";

enum ClickSignServiceEnum {
  reSendEmail = "/resend-email/",
  signedDocuments = "/signed-documents/",
  reSendWhatsapp = "/resend-whatsapp/",
  signedDocumentsConvenio = "/signed-documents-convenio/"
}

export default class ClickSignService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/clickSign");
  }
  public resendEmail = async keySinger => await this.GET(ClickSignServiceEnum.reSendEmail + keySinger);
  public resendWhatsapp = async keySinger => await this.GET(ClickSignServiceEnum.reSendWhatsapp + keySinger);

  public getSignedDocumentsByTrade = async tradeId => await this.GET(ClickSignServiceEnum.signedDocuments + tradeId);

  public getSignedDocumentsByTradeConvenio = async tradeConvenioId => await this.GET(ClickSignServiceEnum.signedDocumentsConvenio + tradeConvenioId);
  
}


// WEBPACK FOOTER //
// ./src/services/api/ClickSign.service.ts